import React from 'react';
import { BankAccount } from '../props';
import AddButton from './AddButton';
import { BankAccountRadioProps } from '../utils';

interface DisplayCampaignBankAccountListProps {
  campaignList?: BankAccount[];
  bankAccountCard: React.ReactNode;
  iconReplace?: React.ReactNode;
  onAddClick: (selection: BankAccountRadioProps) => void;
  isSelected: boolean;
  replaceAccountButtonDisabled: boolean;
  campaignAndPayableAccountsMatch: boolean;
}

const DisplayCampaignBankAccountList: React.FC<
  DisplayCampaignBankAccountListProps
> = ({
  campaignList,
  bankAccountCard,
  iconReplace,
  isSelected,
  replaceAccountButtonDisabled,
  campaignAndPayableAccountsMatch,
  onAddClick,
}) => {
  if (
    campaignList?.[0] &&
    campaignList?.[0].fingerprint &&
    !campaignAndPayableAccountsMatch
  ) {
    return (
      <React.Fragment>
        {bankAccountCard}
        {isSelected ? iconReplace : null}
      </React.Fragment>
    );
  } else {
    return (
      <AddButton
        selected={isSelected}
        replaceAccountButtonDisabled={replaceAccountButtonDisabled}
        onSelect={(selection: BankAccountRadioProps): void => {
          onAddClick(selection);
        }}
        displayError={false}
      />
    );
  }
};

export default DisplayCampaignBankAccountList;
